import { render } from "./MessagesAccView.vue?vue&type=template&id=112998e3"
import script from "./MessagesAccView.vue?vue&type=script&lang=js"
export * from "./MessagesAccView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__